<template>
  <div class="payment-methods-warp">
    <div
      class="payment-methods-item"
      v-for="(item, index) in payModeList"
      :class="{ 'payment-methods-active': payMode.pId === item.pId }"
      :key="index"
      @click="payMode = item"
    >
      <img v-if="item.pPaymentType === 'Eghl_Pay_TQ'" src="@/assets/imgs/icon_thaiqr.png" alt="">
      <img v-else-if="item.pPaymentType === 'Eghl_Pay_AL'" src="@/assets/imgs/icon_alipay.png" alt="">
      <img v-else-if="item.pPaymentType === 'Eghl_Pay_APT'" src="@/assets/imgs/icon_alipay_plus.png" alt="">
      <img v-else-if="item.pPaymentType === 'Eghl_Pay_TM'" src="@/assets/imgs/icon_truemoney.png" alt="">
      <img v-else src="@/assets/imgs/icon_card.png" alt="" />
      <span>{{ item.label }}</span>
    </div>
    <div class="eghlpay-form" id="eghlpay-form"></div>
  </div>
</template>

<script>
import {
  USER_CARD,
  PAYMODE,
  PAY_RECHARGE,
  PAY_CONFIRM
} from "../../apis/payment";
import EghlPay from "./mixins/eghl_pay.js";
export default {
  mixins: [EghlPay],
  props: {
    qrcode: {
      type: String,
      default: ""
    },
    orderId: {
      type: String,
      default: ""
    },
    agentId: {
      type: String,
      default: process.env.VUE_APP_PTID
    },
    payType: {
      type: String,
      default: "YJ"
    },
    amount: {
      type: [Number, String],
      default: 0
    },
    productId: {
      type: String,
      default: ""
    }
  },
  computed: {
    i18n() {
      return this.$t("confirm");
    }
  },
  data() {
    return {
      payModeList: [],
      payMode: null
    };
  },
  methods: {
    onPay() {
      if (!this.payMode) {
        this.$toast("Please select payment method");
        return;
      }
      if (this.payMode.pPaymentType === "Eghl_Pay_CC") {
        this.onEghlPay(
          this.payType,
          this.payMode.pId,
          this.amount,
          this.qrcode,
          this.productId,
          this.orderId,
          'preAuth'
        );
      } else if (this.payMode.pPaymentType === "Eghl_Pay_TQ"
        || this.payMode.pPaymentType === "Eghl_Pay_AL"
        || this.payMode.pPaymentType === "Eghl_Pay_APT"
        || this.payMode.pPaymentType === "Eghl_Pay_TM") {
        this.onEghlPay(
          this.payType,
          this.payMode.pId,
          this.amount,
          this.qrcode,
          this.productId,
          this.orderId,
          'balance'
        );
      }
    },
    async getUserPayCard() {
      this.$loading(true);
      const { data = [] } = await this.$Request("get", USER_CARD, {
        qrcode: this.qrcode,
        orderId: this.orderId,
        agentld: this.agentId
      });
      let cardList = [];
      if (data && data.length) {
        cardList = data.map(item => {
          return {
            phone: "all",
            label: item.pCardnumber,
            ...item.paymentConfig,
            ...item,
            pPaymentType:
              item.paymentWay === "PAYPAL" ? "PAYPAL_CARD" : item.paymentWay
          };
        });
        this.cardList = cardList;
      }
      this.$loading(false);
      return cardList;
    },
    getPayMode() {
      this.$loading(true);
      this.$get(
        `${PAYMODE}?id=${this.qrcode}&pOrderId=${this.orderId}`,
        {},
        async resp => {
          this.$loading(false);
          console.log(resp);
          if (resp.data) {
            let list = resp.data.reduce((acc, v) => {
              if (v.pPaymentType === "Eghl_Pay_CC") {
                v.label = "CREDIT CARD";
                acc.push(v);
              } else if (v.pPaymentType === "Eghl_Pay_TQ") {
                v.label = "Thai QR";
                acc.push(v);
              } else if (v.pPaymentType === "Eghl_Pay_AL") {
                v.label = "Alipay";
                acc.push(v);
              } else if (v.pPaymentType === "Eghl_Pay_APT") {
                v.label = "Alipay+";
                acc.push(v);
              }
              // else if (v.pPaymentType === "Eghl_Pay_TM") {
              //   v.label = "TrueMoney";
              //   acc.push(v);
              // }
              return acc;
            }, []);
            // const plist = await this.getUserPayCard()
            // list = [...plist, ...list]

            this.payModeList = list;

            this.payMode = this.payModeList[0] || null;

            console.log("list======", list);
          }
        },
        error => {
          this.$loading(false);
          this.$confirm({
            title: this.i18n.msg_fail_title,
            content: this.i18n.msg_fail_order,
            confirmText: this.i18n.msg_fail_retry,
            cancelText: this.i18n.msg_fail_cancel
          }).then(() => {
            this.getPayMode();
          });
          console.log(error);
        }
      );
    }
  },
  created() {
    this.getPayMode();
  }
};
</script>

<style lang="less">
.payment-methods-warp {
  display: flex;
  flex-wrap: wrap;
  .payment-methods-item {
    height: 72px;
    padding: 0 24px;
    border: 1px solid #ebebeb;
    border-radius: 20px;
    background-color: #fff;
    margin: 20px 40px 0 0;
    display: flex;
    align-items: center;
    font-size: 28px;
    color: #666666;
    img {
      width: 42px;
      display: block;
      margin-right: 16px;
    }
  }
  .payment-methods-active {
    border-color: rgba(242, 252, 127, 0.3);
    background-color: rgba(242, 252, 127, 0.3);
    color: #000;
  }
  .eghlpay-form {
    display: none;
  }
}
</style>
